import React from 'react';
import {_t} from "../../js/app/common/utils/locale";

export default class Message extends React.Component {

    render() {
        if (this.props && this.props.message) {
            return (
                <div className={'alert alert-' + this.props.message.type + ' ' + this.props.width}>{_t(this.props.message.message)}</div>
            );
        }
        return null;
    }

}